import { useEffect } from 'react';

export const usePageTitle = (title: string) => {
  useEffect(() => {
    const baseTitle = 'MAMDP';
    document.title = title ? `${baseTitle} - ${title}` : `${baseTitle} - Meteorología Aficionada Mar del Plata`;
    
    return () => {
      // Reset to base title when component unmounts
      document.title = `${baseTitle} - Meteorología Aficionada Mar del Plata`;
    };
  }, [title]);
};